<template>
	<div>
		<v-main>
			<v-container fluid>
				<!--        <v-layout justify-center align-center v-resize="onResize">-->
				<v-row>
					<v-col cols="12">
						<v-card width="100%" outlined elevation-0>
							<v-toolbar flat class="border_bottom" shaped>
								<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.permissions') }} </v-toolbar-title>
								<v-spacer></v-spacer>
							</v-toolbar>

							<v-card-text>
								<template v-for="role in permissions">
									<span v-if="role.role_id == 1">Utente</span>
									<span v-else-if="role.role_id == 2">Dipendente</span>
									<v-container fluid>
										<v-row class="no-gutters">
											<v-col cols="12" sm="2" md="2" v-for="(permission, index) in role.permissions" :key="index + '_perm' + role.role_id">
												<v-checkbox v-model="permission.active" :label="permission.module" color="primary" :value="permission.active" hide-details></v-checkbox>
											</v-col>
										</v-row>

										<v-card-actions class="mt-12">
											<v-spacer></v-spacer>
											<v-btn color="primary" class="primary" @click="updatePermission(role.role_id)"> Conferma </v-btn>
										</v-card-actions>
									</v-container>
								</template>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>

				<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
					{{ snackbar.text }}
					<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
				</v-snackbar>
				<!--        </v-layout>-->
			</v-container>
		</v-main>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
	name: 'Permissions',
	data() {
		return {
			permissions: [],
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},

	created() {
		this.setPreload(true);
		let items = this.fetchAllPermissions();
		items.then(result => {
			_.forEach(result, perm => {
				this.permissions.push(perm);
			});

			this.setPreload(false);
		});
	},

	computed: {
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getLanguage: 'profile/getLanguage',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',
		}),

		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchAllPermissions: 'settings/fetchAllPermissions',
			updatePermissions: 'settings/updatePermissions',
		}),
		async updatePermission(role_id) {
			var role_to_update = _.find(this.permissions, { role_id: role_id });
			if (role_to_update) {
				await this.setPreload(true);
				await this.updatePermissions({ _id: role_to_update._id, permissions: JSON.stringify(role_to_update.permissions) });
				await this.setPreload(false);
			}
		},
	},
};
</script>

<style>
/* .v-application--is-ltr .put--selection-controls__input {
     margin-right: 0px!important;
 }
 .put--selection-controls:not(.put--hide-details) .put__slot{
     margin-bottom: 0!important;

 }
 .put__slot{
     margin-bottom: 0!important;
 }
 .v-messages{ display: none}
 !*.active{
     background-color:#F5F5F5
 }*!
 .notActive{
     background-color:#FFFFFF
 }*/
</style>
